module.exports = require("ws");


/*****************
 ** WEBPACK FOOTER
 ** external "ws"
 ** module id = 1
 ** module chunks = 0
 **/